import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardContext = /*#__PURE__*/createContext(undefined);
export const WizardProvider = ({
  dialogBodyStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(WizardContext.Provider, {
    value: {
      dialogBodyStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `Wizard` component.
 * Note: The context is only available when the `Wizard` component is rendered as an ancestor.
 * @returns WizardContext - The context for the `Wizard` component.
 * @returns WizardContext.dialogBodyStyleOverrides - Style overrides to be applied to the `DialogBody` component.
 */
export const useWizardContext = () => {
  return useContext(WizardContext);
};